import { classNames, DY_STRATEGY_IDS } from '../../constants/recommendations';
import { conditionallyRenderAttrs } from '../../functions/renderer';
import { isRecommendationsResponseDYO } from '../../functions/recommendations';
import { RecommendationSlide } from './recommendations-slide';

const RecommendationsSlider = ({ headline, data, style }) => {
  const isDYOSlider = isRecommendationsResponseDYO(data);

  return data.items && data.items.length > 0
    ? `
  <div style="${style}">
    <div
      class="${classNames.SLIDER_CONTAINER}"
      ${conditionallyRenderAttrs(isDYOSlider, [
        { name: 'id', value: data.wId },
        { name: 'data-dy-widget-id', value: data.wId },
        { name: 'data-dy-feed-id', value: data.fId }
      ])}
      ${conditionallyRenderAttrs(!isDYOSlider, [
        {
          name: 'data-gtm-event-source',
          value: 'Inline QuickView Recommendations Slider'
        }
      ])}
    >
      <h3>${headline}</h3>
      <div
        class="${classNames.SLIDER_WRAPPER}"
        ${conditionallyRenderAttrs(isDYOSlider, [
          {
            name: 'data-dy-strategy-id',
            value: data.strId
          }
        ])}
      >
        ${data.items
          .map((rec, i) => RecommendationSlide(rec, i, isDYOSlider))
          .join(' ')}
      </div>
      <div class="${classNames.SLIDER_NAV_ARROW_LEFT}"></div>
      <div class="${classNames.SLIDER_NAV_ARROW_RIGHT}"></div>
    </div>
  </div>`
    : '';
};

export default RecommendationsSlider;



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/components/RecommendationsSlider/recommendations-slider.js
 **/